import { Command, CommandPaletteDialog } from '@st/theme'
import { Organization } from '@st/sdk'
import { useMemo } from 'react'

type Props = {
  onClose: () => void
  organization: Organization
}
export function FolderListCommandPallette({ organization, onClose }: Props) {
  const commands: Command[] = useMemo(() => {
    return [
      {
        id: 'organization-id',
        label: `Organization ID: ${organization.id}`,
        category: 'Organization'
      }
    ]
  }, [organization])

  function onSelect(item: Command) {
    if (item.id === 'organization-id') {
      window.navigator.clipboard.writeText(organization.id)
      onClose()
    }
  }

  return (
    <CommandPaletteDialog
      className="w-1/3"
      onClose={onClose}
      onSelect={onSelect}
      commands={commands}
    />
  )
}
